import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function FridgeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 14.9961V27.7675C4 29.55 5.48424 31 7.30867 31H23.6911C25.5155 31 27 29.55 27 27.7675V14.9961H4ZM10.6176 22.59C10.6176 23.0752 10.2148 23.4689 9.7179 23.4689C9.2212 23.4689 8.81822 23.0752 8.81822 22.59V17.8828C8.81822 17.3973 9.2212 17.0039 9.7179 17.0039C10.2148 17.0039 10.6176 17.3973 10.6176 17.8828V22.59Z"
        fill="currentColor"
      />
      <path
        d="M26.9998 13.2383V4.23227C26.9998 2.44997 25.5155 1 23.6911 1H7.30867C5.48424 1 4 2.44997 4 4.23227V13.2383H26.9998ZM8.81822 6.58586C8.81822 6.10063 9.2212 5.70695 9.7179 5.70695C10.2148 5.70695 10.6176 6.10063 10.6176 6.58586V10.3517C10.6176 10.8369 10.2148 11.2306 9.7179 11.2306C9.2212 11.2306 8.81822 10.8369 8.81822 10.3517V6.58586Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
